// @flow

import * as React from "react";
import { Switch } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import Helmet from "react-helmet";
import { useSelector } from "react-redux";

import PrimaryNav from "../components/organisms/PrimaryNav";
// import MobileNav from "../components/organisms/MobileNav";
import PrimaryFooter from "../components/organisms/PrimaryFooter";
import YoastMeta from "../components/atoms/YoastMeta";
import Routes from "../Routes";
import Config from "../constants/Config";
import GTM from "../utils/gtm";
import AlertModal from "../components/organisms/AlertModal";

const App = (props: any): React.Node => {
    const { navHide } = useSelector((state: any): any => state.ui);
    React.useEffect(() => {
        // hide site preloader on init
        const preloaderEl = document.querySelector(".preloader");
        if (preloaderEl) {
            preloaderEl.classList.add("animated");
            preloaderEl.classList.add("fadeOut");

            setTimeout(() => {
                preloaderEl.remove();
            }, 500);
        }

        // log initial page view (check RouteChange.js for page change event firing)
        GTM.logPageView();
    }, []);

    return (
        <>
            <Helmet defaultTitle="Activate UTS">
                {/* Fix viewport zoom for IOS only to remove input focus viewport
                zoom */}
                {Config.isIos ? (
                    <meta
                        name="viewport"
                        content="width=device-width, initial-scale=1, shrink-to-fit=no, minimum-scale=1, maximum-scale=1"
                    ></meta>
                ) : null}
            </Helmet>

            <YoastMeta />

            <div className="page">
                {!navHide && <PrimaryNav />}

                <div className="page__content">
                    <Switch>{renderRoutes(Routes)}</Switch>
                </div>

                <PrimaryFooter />
            </div>

            <AlertModal />
        </>
    );
};

export default App;
